import { module } from 'modujs';
import { html } from '../utils/environment';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                toggler: 'toggle'
            }
        }
    }

    init() {

        gsap.delayedCall(4,() => {
            this.$('item').forEach((item) => {
                if(item.classList.contains('is-open')) {
                    this.open(item)
                }
            });
        })
    }

    /**
     * Toggler
     *
     * @param item {node}
     */
    toggle(e) {
        let el = e.curTarget;
        let parent = this.parent('item', el);

        if(parent.classList.contains('is-open')) {
            this.close();
        } else {
            this.close();
            this.open(parent);
        }
    }

    /**
     * open
     *
     * @param parentNode item {node}
     */
    open(item) {
        let collapsible = this.$('content', item)[0];
        item.classList.add('is-open');

        gsap.to(collapsible, {
            duration: 0,
            height: this.compute(this.$('inner', item)[0]).height

        });

        gsap.delayedCall(0.4,() => {
            this.call('refresh','Scroll');
        })
    }

    /**
     * Close
     *
     * @param
     */
    close() {
        this.$('item').forEach((item) => {
            item.classList.remove('is-open');

            let collapsible = this.$('content', item)[0];

            if(collapsible) {
                gsap.to(collapsible, 0, {
                    height: 0
                })

                gsap.delayedCall(0.4,() => {
                    this.call('refresh','Scroll');
                })
            }
        })
    }

    /**
     * compute
     *
     * @param
     */
    compute(item) {
        return item.getBoundingClientRect();
    }
}